"use client";

import React from "react";
import { CircleCheck, PhoneMissed, MessageSquare, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function AppShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = ["Instant WhatsApp Text-Back for every missed call", "Unified Inbox: Instant WhatsApp Recovery, WhatsApp & Google in one app", "Send quotes and invoices directly from the job site"];
  return <section id="appshowcase" className="bg-background py-24 overflow-hidden relative">
      {}
      <div className="absolute inset-0 radiating-pattern opacity-50 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`grid lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col gap-6 order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-[4px] bg-primary/10 text-primary w-fit font-semibold text-sm border border-primary/20">
              <MessageSquare className="size-4" />
              <span>The Silent Operator App</span>
            </div>

            <h2 className="h2 text-foreground">
              Manage Your Trade Business From Anywhere
            </h2>

            <p className="body-text text-muted-foreground">
              The system that sends an instant WhatsApp to your missed calls.
            </p>

            <ul className="flex flex-col gap-4 mt-2">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="size-6 text-primary shrink-0" />
                  <span className="text-foreground font-medium">{feature}</span>
                </li>)}
            </ul>

            <div className="mt-6 flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="rounded-[4px] gap-2 w-full sm:w-auto" asChild>
                <Link to="/PricingPage">
                  Secure Founder Spot
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[280px] h-[500px] bg-primary/20 blur-[80px] rounded-full pointer-events-none" />

            {}
            <div className="metallic-border rounded-[4px] p-3 bg-muted shadow-2xl relative z-10 w-full max-w-[320px] transform transition-transform hover:-translate-y-2 duration-500">
              
              {}
              <div className="bg-background rounded-[2px] overflow-hidden relative aspect-[9/19] border border-border flex flex-col shadow-inner">
                
                {}
                <div className="h-6 bg-background flex justify-between items-center px-4 text-[10px] font-medium text-foreground/70 border-b border-border/50">
                  <span>14:30</span>
                  <div className="flex gap-1 items-center">
                    <div className="w-3 h-2 bg-foreground/70 rounded-[1px]" />
                    <div className="w-2 h-2 bg-foreground/70 rounded-full" />
                  </div>
                </div>

                {}
                <div className="bg-background border-b border-border p-4 flex justify-center items-center shrink-0 shadow-sm z-10">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/generic_uk_trades_app_logo.png" alt="Trades Management App" className="h-6 object-contain" />
                </div>

                {}
                <div className="flex-1 bg-muted/30 p-4 flex flex-col gap-4 overflow-y-auto relative">
                  <div className="text-center text-[11px] font-medium text-muted-foreground my-1">
                    Today
                  </div>

                  {}
                  <div className="bg-destructive/10 border border-destructive/20 rounded-[4px] p-3 flex items-start gap-3">
                    <div className="bg-destructive/20 p-1.5 rounded-[2px] shrink-0">
                      <PhoneMissed className="size-4 text-destructive" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-foreground leading-none mb-1">Missed Call</p>
                      <p className="text-xs text-muted-foreground">07700 900077</p>
                    </div>
                  </div>

                  {}
                  <div className="bg-primary text-primary-foreground rounded-[4px] rounded-tl-none p-3 max-w-[85%] self-start shadow-sm relative">
                    <p className="text-[13px] leading-relaxed">
                      Hi, you recently called ThinkLocalPro.com. We are currently on a job. How can we help you today?
                    </p>
                    <div className="text-[9px] text-primary-foreground/70 text-right mt-1.5 font-medium tracking-wide uppercase">
                      Automated • 14:30
                    </div>
                  </div>

                  {}
                  <div className="bg-background border border-border text-foreground rounded-[4px] rounded-tr-none p-3 max-w-[85%] self-end shadow-sm">
                    <p className="text-[13px] leading-relaxed">
                      Hi, I have a leaking pipe that needs fixing ASAP. Can someone come out today?
                    </p>
                    <div className="text-[9px] text-muted-foreground text-right mt-1.5 font-medium">
                      14:32
                    </div>
                  </div>
                  
                  {}
                  <div className="bg-background border border-border rounded-[4px] rounded-tl-none p-2 max-w-[60px] self-start shadow-sm flex items-center justify-center gap-1 h-8">
                    <div className="w-1.5 h-1.5 bg-muted-foreground/40 rounded-full animate-bounce" style={{
                    animationDelay: '0ms'
                  }} />
                    <div className="w-1.5 h-1.5 bg-muted-foreground/40 rounded-full animate-bounce" style={{
                    animationDelay: '150ms'
                  }} />
                    <div className="w-1.5 h-1.5 bg-muted-foreground/40 rounded-full animate-bounce" style={{
                    animationDelay: '300ms'
                  }} />
                  </div>
                </div>

                {}
                <div className="bg-background border-t border-border p-3 flex justify-around items-center shrink-0">
                  <div className="w-6 h-6 rounded-[2px] bg-primary/20 flex items-center justify-center">
                    <MessageSquare className="size-3.5 text-primary" />
                  </div>
                  <div className="w-6 h-6 rounded-[2px] bg-muted flex items-center justify-center">
                     <div className="w-3.5 h-3.5 border-2 border-muted-foreground rounded-full" />
                  </div>
                  <div className="w-6 h-6 rounded-[2px] bg-muted flex items-center justify-center">
                    <div className="w-3.5 h-3.5 bg-muted-foreground rounded-[1px]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}